export const isMobile = '@media screen and (max-width: 769px)';

export default {
    isMobile,
};
